<template>
  <div class="files-result-sortings">
          <span class="order-label">
            Rendezés: 
          </span>
          <div class="search-ordering">
                <SearchSortOrder 
                    v-for="key in sortKeys"
                    :key="key"
                    :sort="sorts[key]"
                    v-on:orderChange="orderChangeHandler($event, key)"
                />
          </div>
        </div>
</template>

<script>
import SearchSortOrder from '@/components/app/search_components/SearchSortOrder.vue';

export default {
    name: 'SearchOrdering',

    components: {
        SearchSortOrder
    },

    props: {
        defaultSorts: {
            type: Object,
            default: () => {return {}}
        }
    },

    created() {
        this.initSorts();
    },

    data() {
        return {
            sortKeys: [],
            sorts: {}
        }
    },

    methods: { 
        initSorts() {
            const sortKeys = Object.keys(this.defaultSorts);
            this.sortKeys = sortKeys;
            this.sorts = {...this.defaultSorts};
        },
        orderChangeHandler($event, key) {
            const newSorts = {...this.defaultSorts};
            newSorts[key] = $event;
            this.sorts = newSorts;
            this.$emit('currentSortChanged', {
                sortField: key,
                sortOrder: $event.order
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .files-result-sortings {
      margin-top: 15px;
      margin-bottom: 15px;
    }
    .search-ordering {
        display: flex;
    }
</style>